import { CamelCaseKeys, NumericString } from '@utils/typescript';
import { BenefitLimit } from './BenefitLimit';

export enum HealthClaimCostItemStatuses {
  Pending = 'pending',
  Approved = 'approved'
}

export type HealthClaimCostItem = CamelCaseKeys<{
  id: number;
  benefit_limit: BenefitLimit | null;
  declared_amount: NumericString;
  approved_amount: NumericString;
  uncovered_expenses_amount: NumericString;
  deductible_copay_amount: NumericString;
  over_limit_amount: NumericString;
  total_covered_amount: NumericString;
  custom_sub_benefit: string;
  remark: string;
  status: HealthClaimCostItemStatuses;
}>;
